<template>
	<div>
  	<div class="window-container" :class="{ 'window-mobile': isDevice }">
			<form class="chatCreateRoom-container"
				@submit.prevent="createRoom" v-if="addNewRoom">
				<v-select 
					multiple 
					v-model="addRoomUsername" 
					:options="this.listOfOptionsUsers"
					:placeholder="$t('ChatComponent.ChatWindow.create_room_search')"
					class="chatCreateRoom-vselect"/>
					<div class="chatCreateRoom-btnContainer">
						<button class="btn-kne-orange" type="submit" :disabled="disableForm || !addRoomUsername">
							{{$t('ChatComponent.ChatWindow.create_room_confirm')}}
						</button>
						<button class="btn-kne-red" @click="addNewRoom = false">
							{{$t('ChatComponent.ChatWindow.cancel')}}
						</button>
					</div>
			</form>

  	  <form @submit.prevent="addRoomUser" v-if="inviteRoomId">
  	    <v-select 
					multiple 
					v-model="invitedUsername" 
					:options="this.listOfOptionsUsers"
					:placeholder="$t('ChatComponent.ChatWindow.invite_user_search')"
					/>
  	    <button type="submit" :disabled="disableForm || !invitedUsername">
  	      {{$t('ChatComponent.ChatWindow.invite_user_confirm')}}
  	    </button>
  	    <button class="button-cancel" @click="inviteRoomId = null">
  	      {{$t('ChatComponent.ChatWindow.cancel')}}
  	    </button>
  	  </form>

  	  <form @submit.prevent="deleteRoomUser" v-if="removeRoomId">
  	    <select v-model="removeUserId">
  	      <option default value="">{{$t('ChatComponent.ChatWindow.remove_user_search')}}</option>
  	      <option v-for="user in removeUsers" :key="user._id" :value="user._id">
  	        {{ user.username }}
  	      </option>
  	    </select>
  	    <button type="submit" :disabled="disableForm || !removeUserId">
  	      {{$t('ChatComponent.ChatWindow.remove_user_confirm')}}
  	    </button>
  	    <button class="button-cancel" @click="removeRoomId = null">
  	      {{$t('ChatComponent.ChatWindow.cancel')}}
  	    </button>
  	  </form>

			<chat-window v-if="$store.state.i18n.locale === 'fr'"
				:text-messages="{
					ROOMS_EMPTY: 'Aucune conversation',
					ROOM_EMPTY: 'Aucune conversation sélectionnée',
					NEW_MESSAGES: 'Nouveaux messages',
					MESSAGE_DELETED: 'Ce message a été supprimé',
					MESSAGES_EMPTY: 'Aucun message',
					CONVERSATION_STARTED: 'La conversation a commencée le :',
					TYPE_MESSAGE: 'Tapez votre message',
					SEARCH: 'Rechercher',
					IS_ONLINE: 'est en ligne',
					LAST_SEEN: 'Dernière connexion ',
					IS_TYPING: 'est en train de taper...'
				}"
				:height="screenHeight"
				:width="screenWidth"
				:theme="theme"
				:styles="styles"
				:current-user-id="currentUserId"
				:room-id="roomId"
				:rooms="loadedRooms"
				:loading-rooms="loadingRooms"
				:messages="messages"
				:messageActions="[
					{
						name: 'replyMessage',
						title: 'Répondre'
					},
					{
						name: 'editMessage',
						title: 'Modifier',
						onlyMe: true
					},
					{
					name: 'deleteMessage',
					title: 'Supprimer',
					onlyMe: true
					}
				]"
				:messages-loaded="messagesLoaded"
				:rooms-loaded="roomsLoaded"
				:room-actions="roomActions"
				:menu-actions="menuActions"
				:room-message="roomMessage"
				@fetch-more-rooms="fetchMoreRooms"
				@fetch-messages="fetchMessages"
				@send-message="sendMessage"
				@edit-message="editMessage"
				@delete-message="deleteMessage"
				@open-file="openFile"
				@open-user-tag="openUserTag"
				@add-room="addRoom"
				@room-action-handler="menuActionHandler"
				@menu-action-handler="menuActionHandler"
				@send-message-reaction="sendMessageReaction"
				@typing-message="typingMessage"
				@toggle-rooms-list="$emit('show-demo-options', $event.opened)"
			>
			</chat-window>

			<chat-window v-else
			:height="screenHeight"
			:width="screenWidth"
			:theme="theme"
			:styles="styles"
			:current-user-id="currentUserId"
			:room-id="roomId"
			:rooms="loadedRooms"
			:loading-rooms="loadingRooms"
			:messages="messages"
			:messages-loaded="messagesLoaded"
			:rooms-loaded="roomsLoaded"
			:room-actions="roomActions"
			:menu-actions="menuActions"
			:room-message="roomMessage"
			@fetch-more-rooms="fetchMoreRooms"
			@fetch-messages="fetchMessages"
			@send-message="sendMessage"
			@edit-message="editMessage"
			@delete-message="deleteMessage"
			@open-file="openFile"
			@open-user-tag="openUserTag"
			@add-room="addRoom"
			@room-action-handler="menuActionHandler"
			@menu-action-handler="menuActionHandler"
			@send-message-reaction="sendMessageReaction"
			@typing-message="typingMessage"
			@toggle-rooms-list="$emit('show-demo-options', $event.opened)"
			>
			</chat-window>
  	  
			<!-- <avatar :username="this.uid"></avatar> -->
  	</div>
	</div>
</template>

<script>

import {
  firebase,
  roomsRef,
  messagesRef,
  usersRef,
  filesRef,
  deleteDbField
} from '../../../firebase'
import { parseTimestamp, isSameDay } from '../../../date'
import ChatWindow from 'vue-advanced-chat'
import 'vue-advanced-chat/dist/vue-advanced-chat.css'
import axios from 'axios'
import Avatar from 'vue-avatar'

import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'

export default {
  components: {
    ChatWindow,
		Avatar,
		vSelect
  },

  props: ['currentUserId', 'theme', 'isDevice'],

  data  () {
		return {
			currentUsername: '',
			listOfOptionsUsers: {},
			roomsPerPage: 15,
			rooms: [],
			roomId: '',
			startRooms: null,
			endRooms: null,
			roomsLoaded: false,
			loadingRooms: true,
			allUsers: [],
			loadingLastMessageByRoom: 0,
			roomsLoadedCount: false,
			selectedRoom: null,
			messagesPerPage: 20,
			messages: [],
			messagesLoaded: false,
			roomMessage: '',
			startMessages: null,
			endMessages: null,
			roomsListeners: [],
			listeners: [],
			typingMessageCache: '',
			disableForm: false,
			addNewRoom: null,
			addRoomUsername: '',
			inviteRoomId: null,
			invitedUsername: '',
			removeRoomId: null,
			removeUserId: '',
			removeUsers: [],
			roomActions: [
				{ name: 'inviteUser', title: this.$t('ChatComponent.ChatWindow.invite_user_option') },
				{ name: 'removeUser', title: this.$t('ChatComponent.ChatWindow.remove_user_option') }
				// { name: 'deleteRoom', title: 'Delete Room' }
			],
			menuActions: [
				{ name: 'inviteUser', title: this.$t('ChatComponent.ChatWindow.invite_user_option') },
				{ name: 'removeUser', title: this.$t('ChatComponent.ChatWindow.remove_user_option') }
				// { name: 'deleteRoom', title: 'Delete Room' }
			],
			styles: { container: { borderRadius: '4px' } }
			// dbRequestCount: 0
		}
	},

	mounted () {
		this.fetchRooms()
		this.updateUserOnlineStatus()
	},

	destroyed () {
		this.resetRooms()
	},

	computed: {
		loadedRooms () {
			return this.rooms.slice(0, this.roomsLoadedCount)
		},
		screenHeight () {
			return 'calc(100vh - 200px)'
			// return this.isDevice ? '100%' : 'calc(100vh - 125px)'
		},
		screenWidth () {
			return this.isDevice ? '100px' : 'calc(100vh - 80px)'
		}
	},

	async created  () {
		await this.getUsers()
	},

	methods: {
		showValue (val) {
			console.log(val)
		},
		resetRooms () {
			this.loadingRooms = true
			this.loadingLastMessageByRoom = 0
			this.roomsLoadedCount = 0
			this.rooms = []
			this.roomsLoaded = true
			this.startRooms = null
			this.endRooms = null
			this.roomsListeners.forEach(listener => listener())
			this.roomsListeners = []
			this.resetMessages()
		},

		resetMessages () {
			this.messages = []
			this.messagesLoaded = false
			this.startMessages = null
			this.endMessages = null
			this.listeners.forEach(listener => listener())
			this.listeners = []
		},

		resetForms () {
			this.disableForm = false
			this.addNewRoom = null
			this.addRoomUsername = ''
			this.inviteRoomId = null
			this.invitedUsername = ''
			this.removeRoomId = null
			this.removeUserId = ''
		},

		async fetchRooms () {
			await this.resetRooms()
			await this.fetchMoreRooms()
		},

		async fetchMoreRooms () {
			if (this.endRooms && !this.startRooms) return (this.roomsLoaded = true)
			let query = roomsRef
				.where('users', 'array-contains', this.currentUserId)
				.orderBy('lastUpdated', 'desc')
				.limit(this.roomsPerPage)

			if (this.startRooms) query = query.startAfter(this.startRooms)

			const rooms = await query.get()
			// this.incrementDbCounter('Fetch Rooms', rooms.size)

			this.roomsLoaded = rooms.empty || rooms.size < this.roomsPerPage

			if (this.startRooms) this.endRooms = this.startRooms
			this.startRooms = rooms.docs[rooms.docs.length - 1]

			const roomUserIds = []
			rooms.forEach(room => {
				room.data().users.forEach(userId => {
					const foundUser = this.allUsers.find(user => user._id === userId)
					if (!foundUser && roomUserIds.indexOf(userId) === -1) {
						roomUserIds.push(userId)
					}
				})
			})
			// this.incrementDbCounter('Fetch Room Users', roomUserIds.length)
			const rawUsers = []
			roomUserIds.forEach(userId => {
				const promise = usersRef
					.doc(userId)
					.get()
					.then(user => user.data())

				rawUsers.push(promise)
			})

			this.allUsers = [...this.allUsers, ...(await Promise.all(rawUsers))]

			const roomList = {}

			rooms.forEach(room => {
				roomList[room.id] = { ...room.data(), users: [] }
				room.data().users.forEach(userId => {
					const foundUser = this.allUsers.find(user => user._id === userId)
					if (foundUser) roomList[room.id].users.push(foundUser)
				})
			})

			const formattedRooms = []

			Object.keys(roomList).forEach(key => {
				const room = roomList[key]

				const roomContacts = room.users.filter(
					user => user._id !== this.currentUserId
				)

        room.roomName = roomContacts.map(user => user.username + ' (' + user.company + ')').join(', ') ||
        this.$t('ChatComponent.ChatWindow.myself')

				const roomAvatar =
				roomContacts.length === 1 && roomContacts[0].avatar
						? roomContacts[0].avatar
						: require('@/assets/logo.png')

				formattedRooms.push({
					...room,
					roomId: key,
					avatar: roomAvatar,
					index: room.lastUpdated.seconds,
					lastMessage: {
						content: this.$t('ChatComponent.ChatWindow.room_created'),
						timestamp: this.formatTimestamp(
							new Date(room.lastUpdated.seconds),
							room.lastUpdated
						)
					}
				})
			})

			this.rooms = this.rooms.concat(formattedRooms)
			formattedRooms.map(room => this.listenLastMessage(room))

			if (!this.rooms.length) {
				this.loadingRooms = false
				this.roomsLoadedCount = 0
			}

			this.listenUsersOnlineStatus(formattedRooms)
			this.listenRooms(query)
			// setTimeout(() => console.log('TOTAL', this.dbRequestCount), 2000)
		},

		// Triggered only when a new message appears or when loading the last message
		listenLastMessage (room) {
			const listener = messagesRef(room.roomId)
				.orderBy('timestamp', 'desc')
				.limit(1)
				.onSnapshot(messages => {
					// this.incrementDbCounter('Listen Last Room Message', messages.size)
					messages.forEach(message => {
						const lastMessage = this.formatLastMessage(message.data())
						const roomIndex = this.rooms.findIndex(
							r => room.roomId === r.roomId
						)
						this.rooms[roomIndex].lastMessage = lastMessage
						this.rooms = [...this.rooms]
					})
					if (this.loadingLastMessageByRoom < this.rooms.length) {
						this.loadingLastMessageByRoom++

						if (this.loadingLastMessageByRoom === this.rooms.length) {
							this.loadingRooms = false
							this.roomsLoadedCount = this.rooms.length
						}
					}
				})

			this.roomsListeners.push(listener)
		},

		formatLastMessage (message) {
			if (!message.timestamp) return
			let content = message.content
			if (message.file) content = `${message.file.name}.${message.file.extension || message.file.type}`
			return {
				...message,
				...{
					content,
					timestamp: this.formatTimestamp(
						new Date(message.timestamp.seconds * 1000),
						message.timestamp
					),
					distributed: true,
					seen: message.sender_id === this.currentUserId ? message.seen : null,
					new:
						message.sender_id !== this.currentUserId &&
						(!message.seen || !message.seen[this.currentUserId])
				}
			}
		},

		// TODO - Error is here because room is undefined
		// Loads all messages from a chatroom
		fetchMessages ({ room, options = {} }) {
			this.roomContacts = []
			this.$emit('show-demo-options', false)
			if (options.reset) {
				this.resetMessages()
				this.roomId = room.roomId
			}

			if (this.endMessages && !this.startMessages) return (this.messagesLoaded = true)

			let ref = messagesRef(room.roomId)
			let query = ref.orderBy('timestamp', 'desc').limit(this.messagesPerPage)

			if (this.startMessages) query = query.startAfter(this.startMessages)

			this.selectedRoom = room.roomId

			query.get().then(messages => {
				// this.incrementDbCounter('Fetch Room Messages', messages.size)
				if (this.selectedRoom !== room.roomId) return

				if (messages.empty) this.messagesLoaded = true

				if (this.startMessages) this.endMessages = this.startMessages

				this.startMessages = messages.docs[messages.docs.length - 1]

				let listenerQuery = ref.orderBy('timestamp')

				if (this.startMessages) listenerQuery = listenerQuery.startAfter(this.startMessages)
				if (this.endMessages) listenerQuery = listenerQuery.endAt(this.endMessages)
				if (options.reset) this.messages = []

				messages.forEach(message => {
					const formattedMessage = this.formatMessage(room, message)
					this.messages.unshift(formattedMessage)
				})

				const listener = listenerQuery.onSnapshot(snapshots => {
					// this.incrementDbCounter('Listen Room Messages', snapshots.size)
					this.listenMessages(snapshots, room)
				})
				this.listeners.push(listener)
			}) // End Query

			const roomUsers = room.users
			// Remove ourselves from roomUsers
			roomUsers.forEach(user => {
				if (user._id !== this.currentUserId) this.roomContacts.push(user._id)
			})

			// Get the current user's username to use in pushNotification()
			const currentUser = room.users.filter(
				user => user._id === this.currentUserId
			)
			this.currentUsername = currentUser[0].username
		},

		// Listens for new messages from a focused chatroom
		listenMessages (messages, room) {
			messages.forEach(message => {
				const formattedMessage = this.formatMessage(room, message)
				const messageIndex = this.messages.findIndex(m => m._id === message.id)
				if (messageIndex === -1) {
					this.messages = this.messages.concat([formattedMessage])
				} else {
					this.$set(this.messages, messageIndex, formattedMessage)
				}
				this.markMessagesSeen(room, message)
			})
		},

		markMessagesSeen (room, message) {
			if (
				message.data().sender_id !== this.currentUserId &&
				(!message.data().seen || !message.data().seen[this.currentUserId])
			) {
				messagesRef(room.roomId)
					.doc(message.id)
					.update({
						[`seen.${this.currentUserId}`]: new Date()
					})
			}
		},

		// Called when fetching messages and listening for messages
		// Formats all the information of a message
		formatMessage (room, message) {
			const senderUser = room.users.find(
				user => message.data().sender_id === user._id
			)
			const { sender_id, timestamp } = message.data()

			return {
				...message.data(),
				...{
					senderId: sender_id,
					_id: message.id,
					seconds: timestamp.seconds,
					timestamp: parseTimestamp(timestamp, 'HH:mm'),
					date: parseTimestamp(timestamp, 'DD MMMM YYYY'),
					username: senderUser ? senderUser.username : null,
					// avatar: senderUser ? senderUser.avatar : null,
					distributed: true
				}
			}
		},

		async sendMessage ({ content, roomId, file, replyMessage }) {
			const message = {
				sender_id: this.currentUserId,
				content,
				timestamp: new Date()
			}

			if (file) {
				message.file = {
					name: file.name,
					size: file.size,
					type: file.type,
					extension: file.extension || file.type,
					url: file.localUrl
				}
				if (file.audio) {
					message.file.audio = true
					message.file.duration = file.duration
				}
			}

			if (replyMessage) {
				message.replyMessage = {
					_id: replyMessage._id,
					content: replyMessage.content,
					sender_id: replyMessage.senderId
				}

				if (replyMessage.file) {
					message.replyMessage.file = replyMessage.file
				}
			}

			const { id } = await messagesRef(roomId).add(message)

			if (file) this.uploadFile({ file, messageId: id, roomId })

			roomsRef.doc(roomId).update({ lastUpdated: new Date() })

			if (file) {
				if (file.type.startsWith('audio')) this.pushNotification('Sent a sound file', this.currentUsername)
					else if (file.type.startsWith('image')) this.pushNotification('Sent a picture', this.currentUsername)
					else this.pushNotification('Sent a file', this.currentUsername)
      } else this.pushNotification(message.content, this.currentUsername)
		},

		// Push notifications
			// notifMessage: Content of text to be shown in notification
			// notifTitle: Title of notification
		async pushNotification (notifMessage, notifTitle) {
      // API of Batch.com, the best push API
			await this.roomContacts.forEach(user => {
				usersRef.doc(user).update({ hasNewMessage: true })
			})

      window.batchSDK(api => {
        var customUID = api.setCustomUserID(this.$store.state.user.uid)
        // After getting customUID, do AXIOS.POST of message.
        customUID.then(response => {
        var apiUrl = 'https://api.batch.com/1.1/2009249BE41E43CEB1E72602CA5D376A/transactional/send'
        var apiPayload = {
          'group_id': 'batch_notification_from_sendMessage_keepneye',
          'recipients': {
            'custom_ids': this.roomContacts
          },
          'message': {
            'title': notifTitle,
            'body': notifMessage
          }
        }

        var axiosHeaders = {
          'headers': {
            'Content-Type': 'application/json; charset=UTF-8',
            'X-Authorization': 'dda8b9175f07b9e158ddb76ce49547b5'
          }
        }
        axios.post(apiUrl, apiPayload, axiosHeaders)
        }) // End .then
      }) // End BatchSDK
		},

		openFile ({ message }) {
			window.open(message.file.url, '_blank')
		},

		async openUserTag ({ user }) {
			let roomId

			this.rooms.forEach(room => {
				if (room.users.length === 2) {
					const userId1 = room.users[0]._id
					const userId2 = room.users[1]._id
					if (
						(userId1 === user._id || userId1 === this.currentUserId) &&
						(userId2 === user._id || userId2 === this.currentUserId)
					) {
						roomId = room.roomId
					}
				}
			})

			if (roomId) return (this.roomId = roomId)
			const query1 = await roomsRef
				.where('users', '==', [this.currentUserId, user._id])
				.get()

			if (!query1.empty) {
				return this.loadRoom(query1)
			}
			let query2 = await roomsRef
				.where('users', '==', [user._id, this.currentUserId])
				.get()

			if (!query2.empty) {
				return this.loadRoom(query2)
			}
			const room = await roomsRef.add({
				users: [user._id, this.currentUserId],
				lastUpdated: new Date()
			})

			this.roomId = room.id
			this.fetchRooms()
		},

		async loadRoom (query) {
			query.forEach(async room => {
				if (this.loadingRooms) return
				await roomsRef.doc(room.id).update({ lastUpdated: new Date() })
				this.roomId = room.id
				this.fetchRooms()
			})
		},

		async editMessage ({ messageId, newContent, roomId, file }) {
			const newMessage = { edited: new Date() }
			newMessage.content = newContent

			if (file) {
				newMessage.file = {
					name: file.name,
					size: file.size,
					type: file.type,
					extension: file.extension || file.type,
					url: file.url || file.localUrl
				}
				if (file.audio) {
					newMessage.file.audio = true
					newMessage.file.duration = file.duration
				}
			} else {
				newMessage.file = deleteDbField
			}

			await messagesRef(roomId)
				.doc(messageId)
				.update(newMessage)

			if (file.blob) this.uploadFile({ file, messageId, roomId })
		},

		async deleteMessage ({ message, roomId }) {
			await messagesRef(roomId)
				.doc(message._id)
				.update({ deleted: new Date() })

			const { file } = message

			if (file) {
				const deleteFileRef = filesRef
					.child(this.currentUserId)
					.child(message._id)
					.child(`${file.name}.${file.extension || file.type}`)

				await deleteFileRef.delete()
			}
		},

		// Manage file uploads
		async uploadFile ({ file, messageId, roomId }) {
			let type = file.extension || file.type
			if (type === 'svg' || type === 'pdf') {
				type = file.type
			}

			const uploadFileRef = filesRef
				.child(this.currentUserId)
				.child(messageId)
				.child(`${file.name}.${type}`)

			await uploadFileRef.put(file.blob, { contentType: type })
			const url = await uploadFileRef.getDownloadURL()

			await messagesRef(roomId)
				.doc(messageId)
				.update({
					'file.url': url
				})
		},

		async sendMessageReaction ({ reaction, remove, messageId, roomId }) {
			const dbAction = remove
				? firebase.firestore.FieldValue.arrayRemove(this.currentUserId)
				: firebase.firestore.FieldValue.arrayUnion(this.currentUserId)

			await messagesRef(roomId)
				.doc(messageId)
				.update({
					[`reactions.${reaction.name}`]: dbAction
				})
		},

		// Updates array of currently typing users in a chat
		typingMessage ({ message, roomId }) {
			if (!roomId) return

			// TODO Revisit this, needed or not?
			// if (message.length > 1) {
			// 	return (this.typingMessageCache = message)
			// }

			// if (message.length === 1 && this.typingMessageCache) {
			// 	return (this.typingMessageCache = message)
			// }

			this.typingMessageCache = message

			const dbAction = message
				? firebase.firestore.FieldValue.arrayUnion(this.currentUserId)
				: firebase.firestore.FieldValue.arrayRemove(this.currentUserId)

			roomsRef.doc(roomId).update({
				typingUsers: dbAction
			})
		},

		async listenRooms (query) {
			const listener = query.onSnapshot(rooms => {
				// this.incrementDbCounter('Listen Rooms Typing Users', rooms.size)
				rooms.forEach(room => {
					const foundRoom = this.rooms.find(r => r.roomId === room.id)
					if (foundRoom) {
						foundRoom.typingUsers = room.data().typingUsers
						foundRoom.index = room.data().lastUpdated.seconds
					}
				})
			})
			this.roomsListeners.push(listener)
		},

		// Updates user status (offline/online) in the database
		updateUserOnlineStatus () {
			const userStatusRef = firebase
				.database()
				.ref('/status/' + this.currentUserId)

			const isOfflineData = {
				state: 'offline',
				lastChanged: firebase.database.ServerValue.TIMESTAMP
			}

			const isOnlineData = {
				state: 'online',
				lastChanged: firebase.database.ServerValue.TIMESTAMP
			}

			firebase
				.database()
				.ref('.info/connected')
				.on('value', snapshot => {
					if (snapshot.val() === false) return // === changed from ==

					userStatusRef
						.onDisconnect()
						.set(isOfflineData)
						.then(() => {
							userStatusRef.set(isOnlineData)
						})
				})
		},

		// Listens for changes of online/offline users
		listenUsersOnlineStatus (rooms) {
			rooms.map(room => {
				room.users.map(user => {
					const listener = firebase
						.database()
						.ref('/status/' + user._id)
						.on('value', snapshot => {
							if (!snapshot || !snapshot.val()) return

							const lastChanged = this.formatTimestamp(
								new Date(snapshot.val().lastChanged),
								new Date(snapshot.val().lastChanged)
							)

							user.status = { ...snapshot.val(), lastChanged }

							const roomIndex = this.rooms.findIndex(
								r => room.roomId === r.roomId
							)

							this.$set(this.rooms, roomIndex, room)
						})
					this.roomsListeners.push(listener)
				})
			})
		},

		// Fetch all users to display in the v-select of menu/room actions. Excludes yourself
		async getUsers () {
			const tempListOfSelectedUsers = []
			const currentUserIdStr = this.currentUserId

			const listOfUsers = await usersRef.get()
			await listOfUsers.forEach(doc => {
				if (currentUserIdStr === doc.data()._id) return
				tempListOfSelectedUsers.push({ label: doc.data().username + ' (' + doc.data().company + ')', value: doc.data()._id })
			})
			this.listOfOptionsUsers = tempListOfSelectedUsers
		},

		// List of actions when clicking on triple dots or room down-arrow
		menuActionHandler ({ action, roomId }) {
			switch (action.name) {
				case 'inviteUser':
					return this.inviteUser(roomId)
				case 'removeUser':
					return this.removeUser(roomId)
				case 'deleteRoom':
					return this.deleteRoom(roomId)
			}
		},

		// Create a new room
		addRoom () {
			this.resetForms()
			this.addNewRoom = true
		},

		async createRoom () {
			this.disableForm = true

			// Must keep const name as (id), otherwise doesn't work
			const { id } = await roomsRef.add({
				users: [this.currentUserId],
				lastUpdated: new Date()
			})
			await this.addRoomUsername.forEach(doc => {
				roomsRef.doc(id).update({
					users: firebase.firestore.FieldValue.arrayUnion(doc.value)
				})
			})

			this.addNewRoom = false
			this.addRoomUsername = ''
			this.fetchRooms()
		},

		// Add a user to an existing room
		inviteUser (roomId) {
			this.resetForms()
			this.inviteRoomId = roomId
		},

		async addRoomUser () {
			this.disableForm = true

			await this.invitedUsername.forEach(doc => {
				roomsRef.doc(this.inviteRoomId).update({
					users: firebase.firestore.FieldValue.arrayUnion(doc.value),
					lastUpdated: new Date()
				})
			})

			this.inviteRoomId = null
			this.invitedUsername = ''
			this.fetchRooms()
		},

		// Remove a user from a room
		removeUser (roomId) {
			this.resetForms()
			this.removeRoomId = roomId
			this.removeUsers = this.rooms.find(room => room.roomId === roomId).users
		},

		async deleteRoomUser () {
			this.disableForm = true

			await roomsRef.doc(this.removeRoomId).update({
				users: firebase.firestore.FieldValue.arrayRemove(this.removeUserId),
				lastUpdated: new Date()
			})

			this.removeRoomId = null
			this.removeUserId = ''
			this.fetchRooms()
		},

		// Delete room
		// TODO - Look at issues in Github for more details:
		//		https://github.com/KeepNEye/KeepNeyeVue/issues/16
		async deleteRoom (roomId) {
			const ref = messagesRef(roomId)

			ref.get().then(res => {
				if (res.empty) return
				res.docs.map(doc => ref.doc(doc.id).delete())
			})

			await roomsRef.doc(roomId).delete()

			this.fetchRooms()
		},

		// Format timestamp
		formatTimestamp (date, timestamp) {
			const timestampFormat = isSameDay(date, new Date()) ? 'HH:mm' : 'DD/MM/YY'
			const result = parseTimestamp(timestamp, timestampFormat)
			return timestampFormat === 'HH:mm' ? this.$t('ChatComponent.ChatWindow.today') + `, ${result}` : result
		}
	} // Method end
}
</script>

<style scoped>
	.chatCreateRoom-container{
		display: flex;
		justify-content: space-between;
	} 
	.chatCreateRoom-vselect {
		width: 90%;
	}
  .chatCreateRoom-btnContainer {
		display: flex;
	}
	
	.window-container {
		width: 100%;
		height: 50% !important;
	}
	 .window-mobile{
		overflow-x: hidden;
	}
	 form {
		padding-bottom: 5px;
	}
	 input {
		padding: 5px;
		width: 140px;
		height: 21px;
		border-radius: 4px;
		border: 1px solid #d2d6da;
		outline: none;
		font-size: 14px;
		vertical-align: middle;
	}
	 input::placeholder {
		color: #9ca6af;
	}
	button {
		background: #1976d2;
		color: #fff;
		outline: none;
		cursor: pointer;
		border-radius: 4px;
		padding: 8px 12px;
		margin-left: 10px;
		border: none;
		font-size: 14px;
		transition: 0.3s;
		vertical-align: middle;
	}
	button:hover {
		opacity: 0.8;
	}
	button:active {
		opacity: 0.6;
	}
	button:disabled {
		cursor: initial;
		background: #c6c9cc;
		opacity: 0.6;
	}
	.button-cancel {
		color: #a8aeb3;
		background: none;
		margin-left: 5px;
	}
	select {
		vertical-align: middle;
		height: 33px;
		width: 152px;
		font-size: 13px;
		margin: 0 !important;
	}
	.vs--searchable {
    margin: 0.2rem;
    background-color: white;
	  cursor: pointer;
  }
  .vs__actions {
    cursor: pointer !important;
  }
</style>
